import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

import { Col, Row } from "reactstrap";
import Layout from "../../components/Layout/Layout";

import { useEffect, useState } from "react";
import ButtonComponent from "../../components/ButtonComponent";
import useDynamicComponent from "../../components/dynamics/useDynamicComponent";
import { useAvailableModulesContext } from "../../context/AvailableModulesContext";
import Routes from "../../helpers/Routes";

export default function EquipmentIndex() {
  const MainContent = useDynamicComponent("EquipmentIndex");

  //Declaração de outros estados e variáveis importantes
  const navigate = useNavigate();

  const { availableModules } = useAvailableModulesContext();
  const [isActiveErpEquipments, setIsActiveErpEquipments] = useState<boolean>(false);

  useEffect(() => {
    if (availableModules.includes("IsActiveErpEquipments")) {
      setIsActiveErpEquipments(true);
    }
  }, [availableModules]);

  const onNewTaskClick = () => {
    navigate(Routes.equipments.create);
  };

  const intl = useIntl();

  return (
    <Layout>
      <div className="pageContainer">
        <div className="pageHeader">
          <span className="pageTitle">
            <FormattedMessage id="Screens.Equipments.Title" />
          </span>
        </div>

        <Row>
          <Col
            xl={2}
            lg={3}
            md={3}
            sm={12}
            xs={12}
            style={{ marginTop: "1em" }}
          >
            <ButtonComponent
              text={intl.formatMessage({ id: "Screens.Equipments.Button.CreateEquipment" })}
              onClick={onNewTaskClick}
              disabled={isActiveErpEquipments}
            />
          </Col>
        </Row>

        <div className="pageBody">{MainContent}</div>
      </div>
    </Layout>
  );
}
